'use strict';

var backendErrors = require('@keplr/backend-errors');

const LegacyCartErrors = {
    [backendErrors.Segment]: '08',
    InvalidCart: {
        message: `Votre panier est invalide`,
        code: '0003',
        statusCode: 422,
    },
    EmptyCart: {
        message: `Votre panier est vide`,
        code: '0004',
        statusCode: 422,
    },
    CartNotFound: {
        message: `Le panier est introuvable`,
        code: '0005',
        statusCode: 404,
    },
    TooManyUpdatesInARow: {
        message: `Trop d'appels à la mise à jour du panier, la demande n'a pas pu être traitée`,
        code: '0016',
        statusCode: 429,
    },
};
const CartErrors = {
    [backendErrors.Segment]: '01',
    MissingDataForCreation: {
        code: '0001',
        message: 'Impossible de créer un panier sans adresse et créneau de livraison',
        statusCode: 400,
    },
    ProductQuantityNotEditable: {
        code: '0002',
        message: 'La modification de la quantité de ce produit est interdite',
        statusCode: 400,
    },
    ProductQuantityUnavailable: backendErrors.createBusinessErrorWithmeta({
        code: '0003',
        message: "La quantité sélectionnée n'est pas disponible",
        statusCode: 400,
    }),
    ProductOutOfStock: backendErrors.createBusinessErrorWithmeta({
        code: '0004',
        message: "Le produit n'est pas disponible pour le créneau sélectionné",
        statusCode: 400,
    }),
    WaitingForBankReply: {
        code: '0004',
        message: "Le paiement de votre dernière commande est en attente d'une réponse de votre banque. Il n'a pas encore été validé. Vous pourrez repasser votre commande dans 10 minutes",
        statusCode: 400,
    },
    TotalAmountOutdated: {
        code: '0005',
        message: "Le montant total de votre commande n'est pas à jour. Veuillez rafraîchir la page.",
        statusCode: 400,
    },
    MinOrderAmountNotReached: backendErrors.createBusinessErrorWithmeta({
        code: '0006',
        message: ({ minOrderAmountWithCurrency, paymentCancelled = false, }) => `Le montant estimé des produits n'atteint pas le minimum de commande de ${minOrderAmountWithCurrency}.${paymentCancelled ? ` Le paiement a été annulé.` : ''}`,
        statusCode: 422,
    }),
    CantPrepayPaypal72h: {
        code: '0007',
        message: "Le paiement PayPal n'est pas disponible pour les commandes à plus de 3 jours. Merci de sélectionner un autre moyen de paiement.",
        statusCode: 422,
    },
    OrderNoMoreCompletable: backendErrors.createBusinessErrorWithmeta({
        code: '0008',
        message: "Il n'est plus possible d'ajouter des produits sur cette commande",
        statusCode: 409,
    }),
    NoCouponWithOrderCompletion: {
        code: '0009',
        message: 'Impossible d’ajouter un coupon pour un complément de commande',
        statusCode: 422,
    },
    CustomerDataLockedWithOrderCompletion: {
        code: '0010',
        message: 'Impossible de modifier vos informations pour un complément de commande',
        statusCode: 422,
    },
    InitialOrderNotFound: backendErrors.createBusinessErrorWithmeta({
        code: '0011',
        message: 'Commande initiale introuvable. ',
        statusCode: 404,
    }),
    ProductNotFound: {
        code: '0012',
        message: "Le produit n'est plus disponible pour le créneau sélectionné",
        statusCode: 404,
    },
};
const AuthErrors = {
    [backendErrors.Segment]: '02',
    InvalidCredentials: {
        code: '0001',
        message: 'Email ou mot de passe incorrect',
        statusCode: 401,
    },
    Unauthorized: {
        code: '0002',
        message: 'Vous devez être connecté pour faire cette action',
        statusCode: 401,
    },
    EmailAlreadyTaken: {
        message: `L'email fourni est déjà pris`,
        code: '0003',
        statusCode: 422,
    },
    PhoneAlreadyTaken: {
        message: `Le numéro de téléphone fourni est déjà pris`,
        code: '0004',
        statusCode: 422,
    },
    InvalidSmsVerificationCode: {
        message: 'Le code saisi ne correspond pas à celui envoyé par sms. Veuillez saisir le code à nouveau',
        code: '0005',
        statusCode: 422,
    },
    InvalidPhoneNumber: {
        message: 'Le numéro de téléphone saisi est invalide. Veuillez le saisir à nouveau',
        code: '0007',
        statusCode: 422,
    },
    ExpiredSmsVerificationCode: {
        message: 'Le code de vérification a expiré. Veuillez en demander un nouveau',
        code: '0008',
        statusCode: 422,
    },
    UnableToObtainSmsVerificationCode: {
        message: `Le code de vérification n'a pas pu être envoyé. Veuillez réessayer plus tard`,
        code: '0009',
        statusCode: 429,
    },
    UnableToCheckSmsVerificationCode: {
        message: `Le code de vérification n'a pas pu être vérifié. Veuillez réessayer plus tard`,
        code: '0010',
        statusCode: 429,
    },
    SmsVerificationCodeMissing: {
        message: `Le code de vérification est manquant`,
        code: '0011',
        statusCode: 400,
    },
    AccountRecentlyDeleted: {
        message: `Numéro refusé. Un compte a déjà été associé à ce numéro.`,
        code: '0012',
        statusCode: 422,
    },
    TokenExpired: {
        code: '0013',
        message: 'Le lien a expiré',
        statusCode: 410,
    },
};
const CategoryErrors = {
    [backendErrors.Segment]: '03',
    NotFound: {
        code: '0001',
        message: 'Catégorie non trouvée',
        statusCode: 404,
    },
};
const GenericErrors = {
    [backendErrors.Segment]: '04',
    TooManyRequest: {
        code: '0001',
        message: 'Le nombre de demandes limite a été atteint, réessayez plus tard',
        statusCode: 429,
    },
    GatewayTimeout: {
        code: '0002',
        message: `Le service n'est pas disponible pour l'instant, réessayez plus tard`,
        statusCode: 504,
    },
    MissingAuthHeader: {
        code: '0003',
        message: 'Header Authorization manquant',
        statusCode: 401,
    },
    InvalidAuthHeader: {
        code: '0004',
        message: 'Header Authorization invalide',
        statusCode: 401,
    },
    Unavailable: {
        code: '0005',
        message: `Le service n'est pas disponible pour l'instant, réessayez plus tard`,
        statusCode: 503,
    },
};
const PaymentErrors = {
    [backendErrors.Segment]: '05',
    Stripe: {
        [backendErrors.Segment]: '01',
        InvalidSignature: {
            code: '0001',
            message: 'La signature du webhook est invalide',
            statusCode: 400,
        },
    },
};
const CustomerErrors = {
    [backendErrors.Segment]: '06',
    OngoingOrder: {
        code: '0001',
        message: "La suppression de votre compte n'est pas possible car vous avez une commande en cours",
        statusCode: 400,
    },
    EmailInvalid: {
        code: '0002',
        message: "L'adresse email n'est pas valide",
        statusCode: 400,
    },
    AddressNotFound: {
        code: '0003',
        message: 'Adresse introuvable.',
        statusCode: 404,
    },
    MissingInformation: {
        message: 'Votre nom, prénom, téléphone et adresse email doivent être renseignés pour pouvoir commander',
        code: '0004',
        statusCode: 422,
    },
    InvalidPassword: {
        message: `Le mot de passe doit contenir au moins une lettre majuscule et un chiffre et être long d'au moins 8 lettres.`,
        code: '0005',
        statusCode: 422,
    },
    NotFound: {
        message: 'Compte client introuvable',
        code: '0006',
        statusCode: 400,
    },
};
const ListErrors = {
    [backendErrors.Segment]: '07',
    NotFound: {
        code: '0001',
        message: "La liste n'existe pas",
        statusCode: 404,
    },
    ProductNotFound: {
        code: '0002',
        message: 'Le produit est introuvable',
        statusCode: 404,
    },
    ProductAlreadyExist: {
        code: '0003',
        message: 'Le produit est déjà présent dans la liste',
        statusCode: 422,
    },
    DeliveryZoneNotFound: {
        code: '0004',
        message: 'La zone de livraison est introuvable',
        statusCode: 404,
    },
};
const OrderErrors = {
    [backendErrors.Segment]: '08',
    CannotModify: {
        code: '0001',
        message: 'Impossible de modifier une commande déjà préparée ou annulée.',
        statusCode: 422,
    },
    DeliveryManAlreadyAssigned: {
        code: '0002',
        message: `Un livreur a pris en charge votre commande, vous ne pouvez plus modifier le créneau.`,
        statusCode: 422,
    },
    InvalidTimeSlot: {
        code: '0003',
        message: `Le créneau sélectionné n’est plus disponible, veuillez en sélectionner un autre.`,
        statusCode: 422,
    },
    CannotModifyNoTimeSlots: {
        code: '0004',
        message: `Votre créneau de livraison a été supprimé, vous ne pouvez pas modifier votre commande.`,
        statusCode: 422,
    },
    InvalidTimeSlotDay: {
        code: '0005',
        message: `Le jour du créneau sélectionné ne correspond pas à celui choisi initialement.`,
        statusCode: 422,
    },
    TimeSlotPriceTooHigh: {
        code: '0006',
        message: `Le créneau sélectionné a des frais de livraison supérieurs à celui choisi initialement.`,
        statusCode: 422,
    },
    NotFound: {
        code: '0007',
        message: 'Commande introuvable. ',
        statusCode: 404,
    },
    TimeSlotDeleted: {
        message: `Le créneau de livraison n'est plus valide`,
        code: '0008',
        statusCode: 410,
    },
};
const RecipeErrors = {
    [backendErrors.Segment]: '09',
    NotFound: {
        code: '0001',
        message: 'La recette est introuvable',
        statusCode: 404,
    },
};
const FleetManagerErrors = {
    [backendErrors.Segment]: '10',
    TaskDeliveryInfosNotFound: {
        code: '0001',
        message: `Impossible de récupérer les informations de la tâche de livraison`,
        statusCode: 404,
    },
};
const ShopErrors = {
    [backendErrors.Segment]: '11',
    NotFoundFromQuery: {
        code: '0001',
        message: 'Le magasin est introuvable',
        statusCode: 400,
    },
    ActiveCatalogNotFound: {
        code: '0002',
        message: 'Le catalogue de produits est introuvable',
        statusCode: 404,
    },
};
const DeliveryErrors = {
    [backendErrors.Segment]: '12',
    NoTimeSlotAvailable: {
        code: '0001',
        message: 'Aucun créneau disponible pour votre zone de livraison.',
        statusCode: 422,
    },
    TimeSlotExcluded: {
        code: '0002',
        message: "Le créneau de livraison n'est plus disponible.",
        statusCode: 422,
    },
    NoDeliveryForAddress: {
        code: '0003',
        message: 'Impossible de livrer votre adresse',
        statusCode: 403,
    },
};
const ReferralErrors = {
    [backendErrors.Segment]: '13',
    AlreadyOrdered: {
        code: '0001',
        message: "Vous n'êtes plus éligible au parrainage car vous avez déjà passé commande",
        statusCode: 400,
    },
    Anonymous: backendErrors.createBusinessErrorWithmeta({
        code: '0002',
        statusCode: 400,
        message: 'Vous devez être connecté pour saisir un code parrain',
    }),
    AlreadyReferred: {
        code: '0003',
        statusCode: 400,
        message: 'Vous êtes déjà parrainé',
    },
    ReferralCodeNotFound: {
        code: '0004',
        statusCode: 404,
        message: "Le code parrain n'existe pas",
    },
};
const SearchErrors = {
    [backendErrors.Segment]: '14',
    LegacyNotPaginated: {
        code: '0001',
        message: 'La recherche legacy ne peut pas être paginée',
        statusCode: 400,
    },
};
const CouponErrors = {
    [backendErrors.Segment]: '15',
    AlreadyUsed: backendErrors.createBusinessErrorWithmeta({
        message: 'Le code promo a déjà été utilisé',
        code: '0001',
        statusCode: 417,
    }),
    CouponCreationFailed: backendErrors.createBusinessErrorWithmeta({
        code: '0002',
        message: 'La création du coupon a échoué',
        statusCode: 417,
    }),
};
const ArticleErrors = {
    [backendErrors.Segment]: '16',
    ArticleNotFound: backendErrors.createBusinessErrorWithmeta({
        code: '0001',
        message: "Cet article n'existe pas",
        statusCode: 404,
    }),
};
const BusinessErrors = {
    [backendErrors.Segment]: 'E',
    Order: LegacyCartErrors,
    EcomErrors: {
        [backendErrors.Segment]: 'ECOM',
        Cart: CartErrors,
        Auth: AuthErrors,
        Category: CategoryErrors,
        Generic: GenericErrors,
        Payment: PaymentErrors,
        Customer: CustomerErrors,
        List: ListErrors,
        Order: OrderErrors,
        Recipe: RecipeErrors,
        Shop: ShopErrors,
        Delivery: DeliveryErrors,
        Referral: ReferralErrors,
        Search: SearchErrors,
        Article: ArticleErrors,
        Coupon: CouponErrors,
    },
    FleetManager: FleetManagerErrors,
};
backendErrors.Meta.postProcessErrors(BusinessErrors);

exports.ArticleErrors = ArticleErrors;
exports.AuthErrors = AuthErrors;
exports.BusinessErrors = BusinessErrors;
exports.CartErrors = CartErrors;
exports.CategoryErrors = CategoryErrors;
exports.CouponErrors = CouponErrors;
exports.CustomerErrors = CustomerErrors;
exports.DeliveryErrors = DeliveryErrors;
exports.FleetManagerErrors = FleetManagerErrors;
exports.GenericErrors = GenericErrors;
exports.LegacyCartErrors = LegacyCartErrors;
exports.ListErrors = ListErrors;
exports.OrderErrors = OrderErrors;
exports.PaymentErrors = PaymentErrors;
exports.RecipeErrors = RecipeErrors;
exports.ReferralErrors = ReferralErrors;
exports.SearchErrors = SearchErrors;
exports.ShopErrors = ShopErrors;
